export function textColorCSS(textColor: string | null | undefined) {
  if (!textColor) {
    return undefined;
  }

  return {
    "--litesite-text-color": textColor,
  };
}
